export default __webpack_public_path__ + "static/media/Type 9.b231c262.jpg";